import * as React from "react";
const SvgFavorite20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m10 .34 3.163 6.056L19.9 7.533l-4.781 4.88 1 6.759L10 16.132l-6.119 3.04 1-6.759L.1 7.533l6.737-1.137L10 .34Zm0 4.32L8.15 8.203l-3.942.665 2.797 2.855-.585 3.954L10 13.9l3.58 1.778-.585-3.954 2.797-2.855-3.941-.665L10 4.66Z",
      clipRule: "evenodd"
    })
  );
export default SvgFavorite20Px;
